// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item[data-v-63b75423]{margin:10px!important;display:inline-block;flex:1 1 300px;width:calc(33.333% - 20px)}.logo[data-v-63b75423]{max-width:80%;max-height:80%}.pointer[data-v-63b75423]{cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
